function Cambodia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_823)">
      <path d="M0 16C0 18.7719 0.705188 21.379 1.94544 23.6522L16 25.0435L30.0546 23.6522C31.2948 21.379 32 18.7719 32 16C32 13.2282 31.2948 10.621 30.0546 8.34785L16 6.95654L1.94544 8.34785C0.705188 10.621 0 13.2282 0 16H0Z" fill="#D80027"/>
      <path d="M1.94543 8.34781H30.0545C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94543 8.34781Z" fill="#0052B4"/>
      <path d="M16 31.9999C22.0647 31.9999 27.3409 28.6256 30.0545 23.6521H1.94543C4.65912 28.6256 9.93531 31.9999 16 31.9999Z" fill="#0052B4"/>
      <path d="M21.5651 19.1304V17.0435H20.1739V14.2609L18.7826 12.8695L17.3913 14.2609V11.4782L16 10.0869L14.6086 11.4782V14.2609L13.2173 12.8695L11.826 14.2609V17.0435H10.4348V19.1304H9.04346V21.2174H22.9565V19.1304H21.5651Z" fill="#F0F0F0"/>
    </g>
  </svg>
  `;

  return baseXml;
}

export default Cambodia;
